import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { catchError, map, of, tap } from 'rxjs';
import { AuthService } from './auth.service';

// El login vive en otro subdominio (unilogin): sin sesión válida se sale de la app.
export const authGuard: CanActivateFn = () => {
  const auth = inject(AuthService);

  return auth.entrarAlModulo().pipe(
    map(() => true),
    catchError(() => {
      auth.irAlLogin();
      return of(false);
    }),
  );
};

// Encuesta del trabajador: sólo exige sesión, sin entrar al módulo GEM. GEM (car.modulo 16) no
// se contrata: el trabajador tiene acceso a NOM-035 (car.persona_acceso) y llega desde unilogin
// con ese módulo abierto; entrar a GEM le daría 403.
export const sesionGuard: CanActivateFn = () => {
  const auth = inject(AuthService);

  return auth.getLogAcceso().pipe(
    tap((sesion) => auth.sesion.set(sesion)),
    map(() => true),
    catchError(() => {
      auth.irAlLogin();
      return of(false);
    }),
  );
};
